import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'cloneNode',
    pure: true,
    standalone: true
})
export class CloneNodePipe implements PipeTransform {
    transform(node: Node | null | undefined): Node | null {
        return node ? node.cloneNode(true) : null;
    }
}
